<template>
    <section class="hot-panel-card">
        <section-title :title="title" />
        <div class="card-container">
            <div v-for="(item, idx) in list" :key="idx" class="card">
                <img class="icon" :src="item.imgUrl" alt="" />
                <span :title="item.name" class="name">{{ item.name }}</span>
            </div>
        </div>
    </section>
</template>

<script>
import SectionTitle from './sectionTitle';

export default {
    name: 'HotPanelCard',
    components: {
        SectionTitle
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        }
    }
};
</script>

<style lang="less" scoped>
.hot-panel-card {
    .card-container {
        display: flex;
        flex-flow: row wrap;

        .card {
            width: 64px;
            height: 64px;
            margin-right: 9px;
            display: flex;
            align-items: center;
            flex-direction: column;
            background: #f8f9fb;
            border-radius: 6px;

            &:nth-child(3n) {
                margin-right: 0;
            }

            &:nth-child(n + 4) {
                margin-top: 8px;
            }

            .icon {
                width: 28px;
                height: 28px;
                margin-top: 8px;
                flex: 0 0 28px;
            }

            .name {
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                color: #262d3d;
                margin-top: 4px;
                max-width: 62px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
